import {
  captureSentryMessage,
  isSentryInitialized,
  Sentry,
} from "@blis/telemetry/client";
import { printZpl } from "@gammapeak/labels/browserprint";

import { toast } from "@/components/ui/toast";
import { isElectron } from "../electron";
import { printViaElectron } from "./electron-print";

function getLabelCount(zplData: string) {
  const matches = zplData.match(/\^XA/g);
  return matches?.length ?? 0;
}

export async function print(zplData: string): Promise<void> {
  const startedAt = Date.now();
  const bytes = new TextEncoder().encode(zplData).byteLength;
  const labelCount = getLabelCount(zplData);
  let success = false;
  const mode = isElectron() ? "electron" : "browserprint";

  try {
    if (mode === "electron") {
      await printViaElectron(zplData);
    } else {
      await printZpl({ zpl: zplData });
    }
    success = true;
  } catch (error) {
    if (mode === "electron") {
      toast.error("Print failed", {
        description: error instanceof Error ? error.message : String(error),
      });
    }

    console.warn("Could not print labels", error);

    captureSentryMessage("Label print metric", {
      level: "warning",
      tags: {
        feature: "labels-print",
        mode,
        result: "failed",
      },
      extra: {
        labelCount,
        bytes,
        durationMs: Date.now() - startedAt,
        error: error instanceof Error ? error.message : String(error),
      },
    });
  }

  if (isSentryInitialized()) {
    Sentry.metrics.count("label.print", labelCount, {
      attributes: {
        success,
        bytes,
        durationMs: Date.now() - startedAt,
        mode,
      },
    });
  }
}
